import { Alert, AlertTitle } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { PlacementVerdict } from '../../shared/placement-check'

export interface PlacementWarningProps {
  verdict?: PlacementVerdict
  sectionName: string
}

export default function PlacementWarning({
  verdict,
  sectionName,
}: PlacementWarningProps) {
  const { formatMessage } = useIntl()

  if (!verdict || verdict.looksRight) {
    return null
  }

  return (
    <Alert severity="warning" data-testid="placement-warning">
      <AlertTitle>
        {formatMessage({ id: 'avatarStudio.preview.placement.title' }, { section: sectionName })}
      </AlertTitle>
      {formatMessage(
        { id: `avatarStudio.preview.placement.${verdict.reason}` },
        { section: sectionName },
      )}
    </Alert>
  )
}
